import { render, staticRenderFns } from "./PopUpSeparation.vue?vue&type=template&id=067d0921&scoped=true"
import script from "./PopUpSeparation.vue?vue&type=script&lang=js"
export * from "./PopUpSeparation.vue?vue&type=script&lang=js"
import style0 from "./PopUpSeparation.vue?vue&type=style&index=0&id=067d0921&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067d0921",
  null
  
)

export default component.exports